import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// AI calls cost fractions of a cent, so small amounts keep 4 decimals.
export function formatUsd(value) {
  const v = Number(value) || 0;
  if (v > 0 && v < 0.01) return `$${v.toFixed(4)}`;
  return `$${v.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
